import { Eye, EyeOff } from 'lucide-react';
import { SpaceListItem } from '../../hooks/useAdminSpaces';
import { WORKFLOW_COLORS, WORKFLOW_LABELS } from '../../constants/spaces.constants';

interface CardImageProps {
  space: SpaceListItem;
  onEdit: (id: string) => void;
}

export function CardImage({ space, onEdit }: CardImageProps) {
  return (
    <div
      onClick={() => onEdit(space.id)}
      style={{
        height: '180px',
        background: space.imageUrl
          ? `url(${space.imageUrl}) center/cover`
          : `linear-gradient(135deg, ${space.colorPrimary || '#00758d'} 0%, ${space.colorAccent || '#8E0B56'} 100%)`,
        position: 'relative',
        cursor: 'pointer',
      }}
    >
      <div
        style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(to bottom, rgba(0,0,0,0.3) 0%, transparent 40%)',
        }}
      />

      <div
        style={{
          position: 'absolute',
          top: '12px',
          left: '12px',
          padding: '0.4rem 0.75rem',
          background: WORKFLOW_COLORS[space.workflow] || '#6b7280',
          color: 'white',
          borderRadius: '8px',
          fontSize: '0.75rem',
          fontWeight: 600,
          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
        }}
      >
        {WORKFLOW_LABELS[space.workflow] || space.workflow}
      </div>

      <div
        style={{
          position: 'absolute',
          top: '12px',
          right: '12px',
          display: 'flex',
          gap: '0.5rem',
        }}
      >
        <div
          style={{
            padding: '0.35rem 0.6rem',
            background: space.isActive ? '#10b981' : '#f59e0b',
            color: 'white',
            borderRadius: '6px',
            fontSize: '0.7rem',
            fontWeight: 700,
            textTransform: 'uppercase',
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
          }}
        >
          {space.isActive ? 'Actif' : 'Inactif'}
        </div>
        <div
          style={{
            padding: '0.35rem 0.6rem',
            background: space.isPublic ? 'rgba(0,117,141,0.9)' : 'rgba(0,0,0,0.6)',
            color: 'white',
            borderRadius: '6px',
            fontSize: '0.7rem',
            fontWeight: 700,
            textTransform: 'uppercase',
            display: 'flex',
            alignItems: 'center',
            gap: '0.3rem',
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
          }}
        >
          {space.isPublic ? <Eye size={12} /> : <EyeOff size={12} />}
          {space.isPublic ? 'Public' : 'Masqué'}
        </div>
      </div>
    </div>
  );
}
